import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import EventCodePage from "./event-code/EventCodePage";
import EventPage from "./event/EventPage";
import { GuestListPage } from "./guest-list/GuestListPage";
import { GuestAddPage } from "./guest-list/GuestAddPage";
import ManualMatchPage from "./manual-matches/ManualMatchPage";
import SetupsPage from "./setups/SetupsPage";

import CommunityNavigationStore, {
  CommunityView,
} from "./navigation/communityNavigationStore";
import { PopUpView } from "./shared/components/PopUpView";
import SchedulePage from "./schedule/SchedulePage";
import CloudBackground from "./shared/components/CloudBackground";
import EventStore from "./event/store/eventStore";
import GuestListStore from "./guest-list/store/guestListStore";

export interface CommunityMatchmakingScreenProps {
  eventGuid: string;
}

const CommunityMatchmakingScreenComponent = observer(
  ({ eventGuid }: CommunityMatchmakingScreenProps) => {
    useEffect(() => {
      console.log("CommunityMatchmakingScreenComponent", { eventGuid });

      if (CommunityNavigationStore.isEventAuthenticated(eventGuid)) {
        const loadEventData = async () => {
          try {
            await EventStore.loadEventData(eventGuid);
            await GuestListStore.loadAttendees(eventGuid);
            CommunityNavigationStore.navigateTo(CommunityView.EVENT_PAGE);
          } catch (err) {
            console.error(
              "Failed to load event data on authenticated refresh:",
              err,
            );
            CommunityNavigationStore.clearEventAuthentication(eventGuid);
            CommunityNavigationStore.navigateTo(CommunityView.EVENT_CODE_ENTRY);
          }
        };
        loadEventData();
      } else {
        CommunityNavigationStore.navigateTo(CommunityView.EVENT_CODE_ENTRY);
      }
    }, [eventGuid]);

    const handleBackToEvent = () => {
      CommunityNavigationStore.navigateTo(CommunityView.EVENT_PAGE);
    };

    const getCurrentView = () => {
      switch (CommunityNavigationStore.currentView) {
        case CommunityView.GUEST_LIST:
          return <GuestListPage onBack={handleBackToEvent} />;
        case CommunityView.GUEST_ADD:
          return <GuestAddPage onBack={handleBackToEvent} />;
        case CommunityView.MANUAL_MATCH:
          return <ManualMatchPage onBack={handleBackToEvent} />;
        case CommunityView.SETUPS:
          return <SetupsPage onBack={handleBackToEvent} />;
        case CommunityView.EVENT_PAGE:
          return <EventPage />;
        case CommunityView.SCHEDULE:
          return (
            <SchedulePage
              onBack={() =>
                CommunityNavigationStore.navigateTo(CommunityView.SETUPS)
              }
            />
          );
        case CommunityView.EVENT_CODE_ENTRY:
        default:
          return <EventCodePage eventGuid={eventGuid} />;
      }
    };

    const getPopUpView = () => {
      if (CommunityNavigationStore.popUpViewProps) {
        return (
          <PopUpView
            {...CommunityNavigationStore.popUpViewProps}
            onClose={() => CommunityNavigationStore.setPopUpView(null)}
          />
        );
      }
      return null;
    };

    return (
      <CloudBackground>
        {getPopUpView()}
        {getCurrentView()}
      </CloudBackground>
    );
  },
);

export default CommunityMatchmakingScreenComponent;
